import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "user-profile-controls",
  class: "position-absolute",
  ref: "profileRef"
}
const _hoisted_2 = {
  key: 0,
  id: "profile-menu",
  class: "py-1 rounded shadow",
  "aria-labelledby": "User-Settings"
}
const _hoisted_3 = {
  class: "dropdown-menu status-menu",
  "aria-labelledby": "defaultDropdown"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "user-profile position-absolute p-3 shadow rounded"
}
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "ava-edit-icon" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "ms-2 fw-semibold" }
const _hoisted_11 = { class: "ms-2 fw-semibold user-email" }
const _hoisted_12 = { class: "profile-colors bg-white rounded p-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "pb-2 fw-semibold" }, "Change Profile Color", -1 /* HOISTED */)
const _hoisted_14 = { class: "d-flex gap-3 mt-1 pb-1" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 2,
  class: "popup-card shadow rounded"
}
const _hoisted_17 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Set Status Message", -1 /* HOISTED */)
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">Never</option><option value=\"2\">Today</option><option value=\"3\">1 hour</option><option value=\"4\">4 hours</option><option value=\"5\">This week</option><option value=\"6\">Custom</option>", 6)
const _hoisted_27 = [
  _hoisted_21
]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "ps-1 pt-2 fw-semibold" }, "Status message will disappear after", -1 /* HOISTED */)
const _hoisted_30 = { class: "d-flex customized-date-options pt-2 gap-1" }
const _hoisted_31 = { class: "customised-date position-relative w-100" }
const _hoisted_32 = { class: "input-group date datepickerInput" }
const _hoisted_33 = ["value"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_35 = ["value"]
const _hoisted_36 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvaInitials = _resolveComponent("AvaInitials")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TimePicker = _resolveComponent("TimePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
    }, [
      _createVNode(_component_AvaInitials, {
        classes: "ava-xs user-settings",
        initialsType: _ctx.AvaInitialsType.Single,
        user: _ctx.loggedInUserDetails,
        showStatus: true
      }, null, 8 /* PROPS */, ["initialsType", "user"])
    ]),
    _createCommentVNode(" Main Menu Dropdown "),
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "menu-item font-size-sm",
            href: "javascript:void(0);",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openViewProfile && _ctx.openViewProfile(...args)))
          }, "View Profile"),
          _createElementVNode("div", {
            class: "menu-item font-size-sm",
            href: "javascript:void(0);",
            "data-bs-toggle": "dropdown",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSetStatus && _ctx.openSetStatus(...args)))
          }, " Set Status "),
          _createCommentVNode(" User Statuses Dropdown "),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.ProfileStatusEnums), ([key, value]) => {
              return (_openBlock(), _createElementBlock("a", {
                class: "dropdown-item font-size-sm",
                key: key,
                onClick: ($event: any) => (_ctx.updateStatus(value.value))
              }, [
                _createElementVNode("img", {
                  src: `${require(`../../../assets/images/chat/status-${value.value === _ctx.ProfileStatusEnum.InACall ? 'busy' : key}.svg`)}`
                }, null, 8 /* PROPS */, _hoisted_5),
                _createTextVNode(" " + _toDisplayString(value.name), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_4))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", {
            class: "menu-item font-size-sm",
            href: "javascript:void(0);",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openSetStatusMsg && _ctx.openSetStatusMsg(...args)))
          }, " Set Status Message ")
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" View Profile Dropdown "),
    (_ctx.activeMenu === 'profile')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "position-relative",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openProfilePicDialog && _ctx.openProfilePicDialog(...args)))
            }, [
              _createVNode(_component_AvaInitials, {
                initialsType: _ctx.AvaInitialsType.Single,
                user: _ctx.loggedInUserDetails
              }, null, 8 /* PROPS */, ["initialsType", "user"]),
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("img", {
                  src: `${require(`../../../assets/images/chat/edit-pencil.svg`)}`
                }, null, 8 /* PROPS */, _hoisted_9)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.userDetails.userName), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.userDetails.email), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.circles, (circle, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["circle cursor-pointer", { selected: index + 1 === _ctx.userDetails.profileColor }]),
                  style: _normalizeStyle(_ctx.circleStyle(circle)),
                  onClick: ($event: any) => (_ctx.updateProfileColor(index))
                }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_15))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Status Message Popup "),
    (_ctx.activeMenu === 'statusMsg')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("small", null, _toDisplayString(_ctx.userDetails.email), 1 /* TEXT */)
            ]),
            _createElementVNode("i", {
              class: "fas fa-times fa-lg mt-3",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.backToRoot && _ctx.backToRoot(...args)))
            })
          ]),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control overflow-hidden",
            rows: "3",
            maxlength: "280",
            placeholder: "Type your status message that should be visible to people",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userStatusMsg) = $event)),
            disabled: _ctx.existingStatusMsg !== null
          }, null, 8 /* PROPS */, _hoisted_20), [
            [_vModelText, _ctx.userStatusMsg]
          ]),
          (!_ctx.existingStatusMsg)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                class: "form-select mt-3",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userStatusMsgTimer) = $event))
              }, _hoisted_27, 512 /* NEED_PATCH */)), [
                [_vModelSelect, _ctx.userStatusMsgTimer]
              ])
            : _createCommentVNode("v-if", true),
          (_ctx.userStatusMsgTimer == 6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_DatePicker, {
                      getDate: _ctx.changeDate,
                      options: {
                                container: '.customised-date',
                                orientation: 'left bottom',
                                startDate: _ctx.dateFrom
                            }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            name: "dateFrom",
                            placeholder: "MM/DD/YYYY",
                            value: _ctx.formatDate(_ctx.dateFrom, 'ddd MMM DD YYYY')
                          }, null, 8 /* PROPS */, _hoisted_33),
                          _hoisted_34
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate", "options"])
                  ]),
                  _createVNode(_component_TimePicker, {
                    class: "ms-1",
                    minTime: _ctx.computedMinTime,
                    onUpdateProps: _ctx.updateStatusMsgTime
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        id: "travel-start-time",
                        type: "text",
                        class: "form-control",
                        value: _ctx.customStatusMsgTime,
                        autocomplete: "off",
                        maxlength: 8
                      }, null, 8 /* PROPS */, _hoisted_35)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["minTime", "onUpdateProps"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.existingStatusMsg)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-md mt-3 btn-primary d-flex m-auto",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetStatusMsg && _ctx.resetStatusMsg(...args)))
              }, " Reset "))
            : (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "btn btn-md mt-3 btn-primary d-flex m-auto",
                disabled: !_ctx.userStatusMsg,
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateStatusMsg && _ctx.updateStatusMsg(...args)))
              }, " Save ", 8 /* PROPS */, _hoisted_36))
        ]))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}